<script>
import ActiveBadge from "@/components/ActiveBadge";
import TotalData from "./TotalData";
import CampaignLogChart from "@/components/campaign/CampaignLogChart";
import SetCampaignStatus from "@/components/campaign/SetCampaignStatus";
import CampaignLogChartGroupByHour from "@/components/campaign/CampaignLogChartGroupByHour";
import CampaignLogChartGroupByApplication from "@/components/campaign/CampaignLogChartGroupByApplication";

export default {
  props: {
    id: {
      type: [Number, String, null],
      required: true,
    },
  },
  components: {
    CampaignLogChartGroupByHour,
    SetCampaignStatus,
    CampaignLogChartGroupByApplication,
    ActiveBadge,
    TotalData,
    CampaignLogChart,
  },
  data() {
    return {
      record: null,
      filter_period: "",
      filter_days: "",
      campaignStatuses: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    this.fetchCampaignMetaData();
  },
  methods: {
    fetchRecord() {
      this.$axios.get(`campaigns/${this.id}/detail`).then((res) => {
        this.record = res.data;
      });
    },
    fetchCampaignMetaData() {
      this.$axios.get(`campaigns/meta-data`).then((res) => {
        this.campaignStatuses = res.data.campaign_statuses;
        this.fetchRecord();
      });
    },
  },
};
</script>

<template>
  <div class="row w-100 mx-auto" v-if="record !== null">
    <b-tabs pills justified content-class="py-3 text-muted w-100">
      <b-tab>
        <template v-slot:title>
          جزئیات کمپین
        </template>
        <div class="row w-100 px-0 mx-auto">
          <div class="col-12 px-0">
            <div class="card">
              <div class="card-body">
                <table class="table table-nowrap mb-0 w-100">
                  <tbody>
                    <tr>
                      <th scope="row" style="width: 400px;">نوع کمپین</th>
                      <td>
                        {{
                          record.campaign_kind !== null
                            ? record.campaign_kind.name
                            : "----"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">نام کمپین</th>
                      <td>{{ record.name }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">توضیحات</th>
                      <td>{{ record.description }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        متن دکمه پایانی
                      </th>
                      <td>{{ record.btnText }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        هزینه به ازای هر
                        <span v-if="record.campaign_kind !== null">{{
                          record.campaign_kind.name
                        }}</span>
                      </th>
                      <td>{{ $helper.formatPrice(record.hazine) }} تومان</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        وضعیت فعال بودن
                      </th>
                      <td>
                        <active-badge :status="record.isActive"></active-badge>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">وضعیت تایید</th>
                      <td>
                        {{ record.campaign_status.name }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        توضیح وضعیت تأیید
                      </th>
                      <td>
                        {{ record.campaign_status_description }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        نمایش تنها در اپلیکیشن های شما
                      </th>
                      <td>
                        <span>
                          <b-badge v-if="record.justMine === 1" variant="danger"
                            >بله</b-badge
                          >
                          <b-badge
                            v-if="record.justMine === 0"
                            variant="success"
                            >خیر</b-badge
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        امکان رد کردن تبلیغ
                      </th>
                      <td>
                        <span>
                          <b-badge v-if="record.canSkip === 1" variant="danger"
                            >بله</b-badge
                          >
                          <b-badge v-if="record.canSkip === 0" variant="success"
                            >خیر</b-badge
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">بودجه روزانه</th>
                      <td>
                        {{ $helper.formatPrice(record.dailybudget) }} تومان
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">بودجه کل</th>
                      <td>
                        {{ $helper.formatPrice(record.totalBudget) }} تومان
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">تاریخ ایجاد</th>
                      <td>{{ record.created_at }}</td>
                    </tr>
                    <tr>
                      <th scope="row">آیکن</th>
                      <td>
                        <img :src="record.picAdd" style="max-height: 100px" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تصویر 1</th>
                      <td>
                        <img :src="record.img1" style="max-height: 100px" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تصویر 2</th>
                      <td>
                        <img :src="record.img2" style="max-height: 100px" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تصویر 3</th>
                      <td>
                        <img :src="record.img3" style="max-height: 100px" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تصویر 4</th>
                      <td>
                        <img :src="record.img4" style="max-height: 100px" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تصویر اشتراک گذاری</th>
                      <td>
                        <img :src="record.sharePic" style="max-height: 100px" />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">ویدئو</th>
                      <td>
                        <video
                          controls
                          :src="record.vidAdd"
                          style="max-height: 100px"
                        ></video>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        زمان شروع نمایش
                      </th>
                      <td>{{ record.start_show_time }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        زمان پایان نمایش
                      </th>
                      <td>{{ record.end_show_time }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        حداقل API اندروید
                      </th>
                      <td>{{ record.minAndroid }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        حداکثر API اندروید
                      </th>
                      <td>{{ record.maxAndroid }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">قالب نمایش</th>
                      <td>
                        <div
                          v-if="parseInt(record.ghalebId) === 1"
                          class="col-12 d-flex flex-column col-md-6"
                        >
                          <div
                            class="d-flex flex-row align-items-center justify-content-start"
                            style="height: 150px"
                          >
                            <div class="col-6 h-100 bg-light"></div>
                            <div class="col-6 h-100">
                              <div
                                class="col-12 bg-light"
                                style="height: 70px;float: top"
                              ></div>
                              <div
                                class="col-12 bg-light"
                                style="height: 30px;float: bottom;margin-top: 50px"
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="parseInt(record.ghalebId) === 2"
                          class="col-12 d-flex flex-column col-md-6"
                        >
                          <div
                            class="d-flex flex-row align-items-center justify-content-start"
                            style="height: 150px"
                          >
                            <div class="col-6 h-100">
                              <div
                                class="col-12 bg-light"
                                style="height: 70px;float: top"
                              ></div>
                              <div
                                class="col-12 bg-light"
                                style="height: 30px;float: bottom;margin-top: 50px"
                              ></div>
                            </div>
                            <div class="col-6 h-100 bg-light"></div>
                          </div>
                        </div>
                        <div
                          v-if="parseInt(record.ghalebId) === 3"
                          class="col-12 d-flex flex-column col-md-6"
                        >
                          <div
                            class="d-flex flex-row align-items-center justify-content-start"
                            style="height: 150px"
                          >
                            <div class="col-6 h-100">
                              <div class="w-100" style="float:top;height: 65px">
                                <div
                                  class="bg-light col-5 h-100"
                                  style="float: right"
                                ></div>
                                <div
                                  class="bg-light col-5 h-100"
                                  style="float: left"
                                ></div>
                              </div>
                              <div
                                class="w-100"
                                style="margin-top: 20px;float: bottom;height: 65px"
                              >
                                <div
                                  class="bg-light col-5 h-100"
                                  style="float: right"
                                ></div>
                                <div
                                  class="bg-light col-5 h-100"
                                  style="float: left"
                                ></div>
                              </div>
                            </div>
                            <div class="col-6 h-100">
                              <div
                                class="col-12 bg-light"
                                style="height: 70px;float: top"
                              ></div>
                              <div
                                class="col-12 bg-light"
                                style="height: 30px;float: bottom;margin-top: 50px"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">
                        نام پکیج اندروید
                      </th>
                      <td>{{ record.androidPkgName }}</td>
                    </tr>
                    <tr>
                      <th scope="row" style="width: 400px;">نام پکیج IOS</th>
                      <td>{{ record.iosPkgName }}</td>
                    </tr>
                    <tr>
                      <th scope="row">رویداد کلیک در گوشی های اندروید</th>
                      <td>
                        <span
                          v-if="
                            record.cafebazarLinkAnd !== '' &&
                              record.cafebazarLinkAnd !== null
                          "
                        >
                          <strong>باز کردن لینک برنامه در کافه بازار</strong>
                          <a :href="record.cafebazarLinkAnd" class="ml-2">
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span
                          v-if="
                            record.playstoreLinkAnd !== '' &&
                              record.playstoreLinkAnd !== null
                          "
                        >
                          <strong>باز کردن لینک برنامه در پلی استور</strong>
                          <a :href="record.playstoreLinkAnd" class="ml-2">
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span
                          v-if="
                            record.intentAnd !== '' && record.intentAnd !== null
                          "
                        >
                          <strong>فراخوانی Intent: </strong>
                          {{ record.intentAnd }}
                        </span>
                        <span
                          v-if="
                            record.linkAnd !== '' && record.linkAnd !== null
                          "
                        >
                          <strong>باز کردن آدرس اینترنتی</strong>

                          <a
                            :href="record.linkAnd"
                            target="_blank"
                            class="ml-2"
                          >
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span
                          v-if="
                            record.phonenoAnd !== '' &&
                              record.phonenoAnd !== null &&
                              (record.smsAnd === '' || record.smsAnd === null)
                          "
                        >
                          <strong>تماس تلفنی با شماره: </strong>
                          {{ record.phonenoAnd }}
                        </span>
                        <span
                          v-if="
                            record.phonenoAnd !== '' &&
                              record.phonenoAnd !== null &&
                              record.smsAnd !== '' &&
                              record.smsAnd !== null
                          "
                        >
                          <strong>ارسال پیامک: </strong>
                          <span>|</span>
                          <span
                            ><strong>شماره: </strong>
                            {{ record.phonenoAnd }}</span
                          >
                          <span>|</span>
                          <span
                            ><strong>متن پیامک: </strong>
                            {{ record.smsAnd }}</span
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">رویداد کلیک در گوشی های IOS</th>
                      <td>
                        <span
                          v-if="
                            record.appStoreIos === '' &&
                              record.linkIos === '' &&
                              record.phonenoIos &&
                              record.smsIos
                          "
                        >
                          ----
                        </span>
                        <span
                          v-if="
                            record.appStoreIos !== '' &&
                              record.appStoreIos !== null
                          "
                        >
                          <strong>باز کردن لینک برنامه در اپ استور</strong>
                          <a :href="record.appStoreIos" class="ml-2">
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span
                          v-if="
                            record.linkIos !== '' && record.linkIos !== null
                          "
                        >
                          <strong>باز کردن آدرس اینترنتی</strong>
                          <a :href="record.linkIos" class="ml-2">
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span
                          v-if="
                            record.phonenoIos !== '' &&
                              record.phonenoIos !== null &&
                              (record.smsIos === '' || record.smsIos === null)
                          "
                        >
                          <strong>تماس تلفنی با شماره: </strong>
                          {{ record.phonenoIos }}
                        </span>
                        <span
                          v-if="
                            record.phonenoIos !== '' &&
                              record.phonenoIos !== null &&
                              record.smsIos !== '' &&
                              record.smsIos !== null
                          "
                        >
                          <strong>ارسال پیامک: </strong>
                          <span>|</span>
                          <span
                            ><strong>شماره: </strong>
                            {{ record.phonenoIos }}</span
                          >
                          <span>|</span>
                          <span
                            ><strong>متن پیامک: </strong>
                            {{ record.smsIos }}</span
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">رویداد کلیک در وبسایت ها</th>
                      <td>
                        <span
                          v-if="
                            record.linkWeb !== '' && record.linkWeb !== null
                          "
                        >
                          <strong>باز کردن آدرس اینترنتی</strong>
                          <a :href="record.linkWeb" class="ml-2">
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span v-else>----</span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">رویداد کلیک در وبسایت های موبایل</th>
                      <td>
                        <span
                          v-if="
                            record.linkMobWeb !== '' &&
                              record.linkMobWeb !== null
                          "
                        >
                          <strong>باز کردن آدرس اینترنتی</strong>
                          <a :href="record.linkMobWeb" class="ml-2">
                            <i class="ri-external-link-line font-size-16"></i
                          ></a>
                        </span>
                        <span v-else>----</span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">محدوده جغرافیایی</th>
                      <td>
                        <span
                          v-for="item in record.locations"
                          :key="item.nameFa"
                        >
                          {{ item.nameFa }} |
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">اپراتورهای تلفن همراه</th>
                      <td>
                        <span
                          v-for="item in record.operators"
                          :key="item.nameFa"
                        >
                          {{ item.nameFa }} |
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تامین کنندگان اینترنت</th>
                      <td>
                        <span
                          v-for="item in record.net_providers"
                          :key="item.nameFa"
                        >
                          {{ item.nameFa }} |
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">برندهای تلفن همراه</th>
                      <td>
                        <span
                          v-for="item in record.mobile_brands"
                          :key="item.nameFa"
                        >
                          {{ item.nameFa }} |
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">تعداد نمایش</th>
                      <td>{{ record.startShow }}</td>
                    </tr>
                    <tr>
                      <th scope="row">تعداد اتمام نمایش</th>
                      <td>{{ record.endShow }}</td>
                    </tr>
                    <tr>
                      <th scope="row">تعداد کلیک</th>
                      <td>{{ record.click }}</td>
                    </tr>
                    <tr>
                      <th scope="row">تعداد نصب</th>
                      <td>{{ record.install }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <SetCampaignStatus
              v-if="user.is_admin"
              :campaign="record"
              :options="campaignStatuses"
            />
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template v-slot:title>اطلاعات آماری</template>
        <div class="row w-100 px-0 mx-auto">
          <total-data :record="record" />
          <div class="col-12 px-0">
            <CampaignLogChart class="w-full" :campaign-id="id" />
          </div>
          <div class="col-12 px-0">
            <CampaignLogChartGroupByHour class="w-full" :campaign-id="id" />
          </div>
          <div class="col-12">
            <CampaignLogChartGroupByApplication
              class="w-full"
              :campaign-id="id"
            />
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<style>
.tabs {
  width: 100%;
}
</style>
